<template>
    <header class="header-global">
        <base-nav class="navbar-main" transparent type="" effect="light" expand>
            <router-link slot="brand" class="navbar-brand mr-lg-5" to="/">
                <img src="img/brand/lc-logo.svg" alt="logo" style="height: 60px;">
            </router-link>

            <div class="row" slot="content-header" slot-scope="{closeMenu}">
                <div class="col-6 collapse-brand">
                    <a href="https://demos.creative-tim.com/vue-argon-design-system/documentation/">
                        <img src="img/brand/blue.png">
                    </a>
                </div>
                <div class="col-6 collapse-close">
                    <close-button @click="closeMenu"></close-button>
                </div>
            </div>

            <ul class="navbar-nav navbar-nav-hover align-items-lg-center">
                <router-link slot="title" to="/" class="nav-link" role="button">
                    <i class="ni ni-ui-04 d-lg-none"></i>
                    <span class="nav-link-inner--text">Home</span>
                </router-link>
                <router-link slot="title" to="/work" class="nav-link" role="button">
                    <i class="ni ni-collection d-lg-none"></i>
                    <span class="nav-link-inner--text">Work</span>
                </router-link>
                <router-link slot="title" to="/about" class="nav-link" role="button">
                    <i class="ni ni-collection d-lg-none"></i>
                    <span class="nav-link-inner--text">About</span>
                </router-link>
                <router-link slot="title" to="/contact" class="nav-link" role="button">
                    <i class="ni ni-collection d-lg-none"></i>
                    <span class="nav-link-inner--text">Contact</span>
                </router-link>
            </ul>
            <ul class="navbar-nav align-items-lg-center ml-lg-auto">
                <li class="nav-item">
                    <a class="nav-link nav-link-icon" href="https://www.linkedin.com/in/moreaujulien/"
                       target="_blank" rel="noopener" data-toggle="tooltip" title="My LinkedIn profile">
                        <i class="fa fa-linkedin"></i>
                        <span class="nav-link-inner--text d-lg-none">linkedin</span>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link nav-link-icon" href="https://stackoverflow.com/users/4926605/lundincast" target="_blank" rel="noopener"
                       data-toggle="tooltip" title="Helping the community">
                        <i class="fa fa-stack-overflow"></i>
                        <span class="nav-link-inner--text d-lg-none">stackoverflow</span>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link nav-link-icon" href="https://github.com/Lundincast"
                       target="_blank" rel="noopener" data-toggle="tooltip" title="Check me on Github">
                        <i class="fa fa-github"></i>
                        <span class="nav-link-inner--text d-lg-none">github</span>
                    </a>
                </li>
            </ul>
        </base-nav>
    </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";

export default {
  components: {
    BaseNav
  }
};
</script>
<style>
</style>
